const Api = {
  install(Vue, options) {
    Vue.prototype.$api = {
      json: {
        courses() {
          return axios.post('/json/courses')
        },
      },
      block: {
        video: {
          create(subpage_id, block_id, data) {
            return axios.post(
              `/home/subpages/${subpage_id}/blocks/${block_id}/create-video`,
              data,
            )
          },
        },
      },
      articlePublish(id) {
        return axios.patch(`/home/articles/${id}/publish`)
      },
      coursePublish(id) {
        return axios.patch(`/home/courses/${id}/publish`)
      },
      courseLectureList(id) {
        return `/home/courses/${id}/sections`
      },

      courses: {
        update(id, data) {
          return axios.put(`/home/courses/${id}/js`, data)
        },
        updateImages(id, data) {
          return axios.put(`/home/courses/${id}/js/images`, data)
        },
      },
      courseEdit(id) {
        return `/home/courses/${id}`
      },
      courseDuplicate(id) {
        return axios.post(`/home/courses/${id}/duplicate`)
      },
      courseStats(id) {
        return `/home/courses/${id}/stats`
      },
      courseLeads(id) {
        return `/home/courses/${id}/leads`
      },
      coursesOrder(data) {
        return axios.post(`/home/courses/order`, data)
      },
      salesPageEdit(id) {
        return `/home/subpages/${id}/edit`
      },
      promoCodesIndex() {
        return axios.get('/home/transactions/promo-codes')
      },
      promoCodesCreate(data) {
        return axios.post(`/home/transactions/promo-codes`, data)
      },
      promoCodesUpdate(id, data) {
        return axios.put(`/home/transactions/promo-codes/${id}`, data)
      },
      promoCodesDelete(id) {
        return axios.delete(`/home/transactions/promo-codes/${id}`)
      },
      storeComment(id, comment) {
        return axios.put(`/json/lectures/${id}/comments`, comment)
      },
      lectures: {
        duplicate(lectureId, courseId) {
          return axios.post(`/home/lectures/${lectureId}/duplicate/${courseId}`)
        },
      },
      student: {
        index(params) {
          return axios.post('/home/students', params)
        },
      },
      transactions: {
        index(params) {
          return axios.post(`/home/transactions`, params)
        },
        invoiceRetry(id) {
          return axios.post(`/home/transactions/${id}/invoice/retry`)
        },
      },
    }
  },
}

export default Api
